export const appBaseURL = "/market/"

export const appBuildAssetsDir = "/_nuxt/"

export const appHead = {"link":[{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":""},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;500;600;700&family=Rubik:wght@300;400;500;600;700&display=swap"},{"rel":"manifest","href":"/market/manifest.json"},{"rel":"icon","type":"image/x-icon","href":"https://sarvban.com/wp-content/uploads/2019/10/android-icon-36x36.png"},{"rel":"shortcut icon","href":"https://sarvban.com/wp-content/uploads/2019/10/android-icon-36x36.png","type":"image/x-icon"},{"rel":"apple-touch-icon","href":"https://sarvban.com/wp-content/uploads/2019/10/apple-icon-180x180.png"},{"rel":"stylesheet","href":"/market/css/bootstrap.min.css"},{"rel":"stylesheet","href":"/market/css/font-awesome.min.css"},{"rel":"stylesheet","href":"/market/css/animate.min.css"},{"rel":"stylesheet","href":"/market/css/owl.carousel.min.css"}],"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover, shrink-to-fit=no"},{"charset":"utf-8"},{"name":"description","content":"بازار خرید و فروش محصولات کشاورزی"},{"name":"theme-color","content":"#7C3AED"},{"name":"msapplication-navbutton-color","content":"#7C3AED"},{"name":"apple-mobile-web-app-status-bar-style","content":"#7C3AED"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"},{"name":"keywords","content":"سروبان ،کشاورزی مدرن،اپلیکیشن کشاورزی، حراجی آنلاین محصولات کشاورزی،اجاره خرید فروش مزرعه و زمین کشاورزی آنلاین،اجاره آنلاین تجهیزات کشاورزی"},{"property":"og:type","content":"website"}],"style":[],"script":[{"src":"/market/js/jquery-3.7.1.min.js","defer":true},{"src":"/market/js/bootstrap.bundle.min.js","defer":true},{"src":"/market/js/owl.carousel.min.js","defer":true},{"children":"\n            var _paq = window._paq = window._paq || [];\n            _paq.push(['setUserId', 'not login']);\n            _paq.push(['trackPageView']);\n            _paq.push(['enableLinkTracking']);\n            (function() {\n              var u=\"//sarvban.com/matomo/\";\n              _paq.push(['setTrackerUrl', u+'matomo.php']);\n              _paq.push(['setSiteId', '1']);\n              var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];\n              g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);\n            })();\n          "},{"children":"\n            var _mtm = window._mtm = window._mtm || [];\n            _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});\n            (function() {\n              var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];\n              g.async=true; g.src='https://sarvban.com/matomo/js/container_3hpRAit6.js'; s.parentNode.insertBefore(g,s);\n            })();\n          "}],"noscript":[],"charset":"utf-8","viewport":"width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover, shrink-to-fit=no","title":"سروبان | بازار خرید و فروش محصولات کشاورزی","htmlAttrs":{}}

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const runtimeCompiler = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true